import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Button, Grid } from "@mui/material";
import { FieldError, useForm } from "react-hook-form";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  // ESTADOS_CONTRATO_CHOICE,
  EstadosContratoChoiceEnum,
  ModulosEnumChoice,
  gridSizeMdLg1,
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg6,
  useCheckPermissions,
  useDownloadFile,
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  useFetchContratos,
  useFetchMotivosRechazo,
} from "@/shared/actions/erp";
import {
  CustomAutocompleteArrString,
  GeneralTable,
  SingleIconButton,
} from "@/shared/components/ui";
import {
  Contrato,
  ESTADOS_INFO_CONTRATO_CHOICE,
  EstadosActualizacionContratoEnum,
} from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { ReactNode } from "react";
import { useColumnsClientes } from "../../../shared/hooks";

export type ClientesCorporativosFiltersMotivosProps = {
  tipoServicio?: string;
};

type FormDataClientes = {
  contratoState: EstadosContratoChoiceEnum;
  estadoInformacionContrato: EstadosActualizacionContratoEnum;
  motivocorreccioncontrato: string;
  canal_venta_create?: string;
  vendedor?: string;
};

const ClientesCorporativosFiltersMotivos: React.FC<
  ClientesCorporativosFiltersMotivosProps
> = ({ tipoServicio = "CORPORATIVOS" }) => {
  useCheckPermissions(PermissionsEnum.api_view_contrato);

  ///* table ---------------------------
  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();
  // const { handleMethodChange, valueTab } = useTabsFormOnly({
  //   initialTabValue: 1,
  // });
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  // const setAlert = useUiStore(s => s.setAlert);

  const {
    // globalFilter,
    pagination,
    searchTerm,
    // onChangeFilter,
    setPagination,
    // cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* form ---------------------------
  const form = useForm<FormDataClientes>({
    defaultValues: {
      contratoState: EstadosContratoChoiceEnum.ALL,
      estadoInformacionContrato: EstadosActualizacionContratoEnum.ALL,
    },
  });
  const { errors } = form.formState;

  const watchedContratoState = form.watch("contratoState");
  const watchedContratoInfoState = form.watch("estadoInformacionContrato");
  const watchedMotivoCorreccion = form.watch("motivocorreccioncontrato", "");

  ///* fetch data ---------------------------
  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    enabled: !!watchedContratoState,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,

      ...(watchedContratoState !== EstadosContratoChoiceEnum.ALL &&
        {
          // estado_contrato: watchedContratoState,
          // estado_contrato: EstadosContratoChoiceEnum.SUSPENDIDO,//MANDO AQUI SOLO LOS QUE ESTAN EN SUSPENDIDO
        }),
      ...(watchedContratoInfoState !== EstadosActualizacionContratoEnum.ALL && {
        estado_actualizacion:
          watchedContratoInfoState ==
          EstadosActualizacionContratoEnum.PENDIENTE_REVISION
            ? "ACTUALIZADO"
            : watchedContratoInfoState ==
                EstadosActualizacionContratoEnum.APROBADO
              ? "REVISADO"
              : watchedContratoInfoState,
      }),
      es_corporativo: true,
      estado_contrato: EstadosContratoChoiceEnum.SUSPENDIDO,
      ...filterObject,
    },
  });

  const {
    data: motivosCorreccionContrato,
    isLoading: isLoadingMotivosCorreccionContrato,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.CONTRATOS,
    page_size: 256,
  });

  const onGenerateExcel = async () => {
    setIsGlobalLoading(true);

    const { handleDownloadFile } = useDownloadFile();
    const URL_GEN_REPORTE = "api/v1/reporte-contrato-contratos/?";
    await handleDownloadFile({
      url: URL_GEN_REPORTE,
      method: "get",
      nameFile: `Reporte Contratos Filtros ${watchedMotivoCorreccion ?? ""} ${
        watchedContratoInfoState || ""
      }`,
      extensionFile: "xlsx",
      params: {
        estado_actualizacion: watchedContratoInfoState,
        observaciones_contrato: watchedMotivoCorreccion,
        estado_contrato: EstadosContratoChoiceEnum.SUSPENDIDO,
        tipo_servicio: tipoServicio,
        preventa_estado_aceptacion: true,
        //filtros desde la tabla
        canal_venta_create: filterObject?.canal_venta_create,
        vendedor: filterObject?.vendedor,
        responsable_razon_social: filterObject?.responsable_razon_social,
        provincia_nombre: filterObject?.provincia_nombre,
        ciudad_nombre: filterObject?.ciudad_nombre,
        numero_referencia: filterObject?.numero_referencia,
        razon_social: filterObject?.razon_social,
      },
    });

    setIsGlobalLoading(false);
  };

  ///* columns ---------------------------
  const { ClientesCorporativosColumnsFilterMotivos } = useColumnsClientes();

  ///* effects ---------------------------
  useLoaders(isLoadingContratos || isRefetchingContratos);

  return (
    <Grid item container {...gridSizeMdLg12}>
      <Grid container item {...gridSizeMdLg12}>
        <Grid
          container
          spacing={1}
          direction={"row"}
          {...gridSizeMdLg6}
          sx={{ marginY: 1 }}
        >
          <CustomAutocompleteArrString
            size={gridSizeMdLg10}
            label="Motivo Corrección"
            name="motivocorreccioncontrato"
            control={form.control}
            defaultValue={form.getValues().motivocorreccioncontrato ?? ""}
            options={
              motivosCorreccionContrato?.data?.data
                ?.map((item) => item.nombre)
                ?.concat([""])!
            }
            isLoadingData={isLoadingMotivosCorreccionContrato}
            error={errors.motivocorreccioncontrato as FieldError}
            helperText={errors.motivocorreccioncontrato?.message as ReactNode}
            // size={gridSizeMdLg12}
            disableClearable
          />
          {/* <div style={{ justifyContent: 'end', display: 'flex', backgroundColor:"rebeccapurple"}}> */}
          <SingleIconButton
            size={gridSizeMdLg1}
            startIcon={<FilterAltOffIcon />}
            onClick={() => {
              form.setValue("motivocorreccioncontrato", "");
            }}
          />
          {/* </div> */}
        </Grid>

        <Grid
          container
          spacing={1}
          direction={"row"}
          {...gridSizeMdLg6}
          sx={{ marginY: 1 }}
        >
          <CustomAutocompleteArrString
            size={gridSizeMdLg10}
            label="Estado Contrato"
            name="estadoInformacionContrato"
            control={form.control}
            defaultValue={
              form.getValues().estadoInformacionContrato ||
              EstadosActualizacionContratoEnum.ALL
            }
            options={ESTADOS_INFO_CONTRATO_CHOICE}
            isLoadingData={false}
            error={errors.estadoInformacionContrato}
            helperText={errors.estadoInformacionContrato?.message}
            // size={gridSizeMdLg12}
            disableClearable
          />
          <SingleIconButton
            size={gridSizeMdLg1}
            startIcon={<FilterAltOffIcon />}
            onClick={() => {
              form.setValue(
                "estadoInformacionContrato",
                EstadosActualizacionContratoEnum.ALL,
              );
            }}
          />
        </Grid>
        <Grid
          container
          {...gridSizeMdLg12}
          alignContent={"center"}
          justifyItems={"center"}
        >
          <Button
            onClick={() => onGenerateExcel()}
            variant="outlined"
            sx={{
              py: 1,
              my: 0,
            }}
            size="small"
          >
            Generar Reporte
          </Button>
        </Grid>
      </Grid>

      <GeneralTable<Contrato>
        columns={ClientesCorporativosColumnsFilterMotivos}
        data={contratosPagingRes?.data?.data || []}
        enableEditing={false}
        enableColumnActions={false}
        //
        isLoading={isLoadingContratos}
        isRefetching={isRefetchingContratos}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={contratosPagingRes?.data?.count}
        toolTipTitleEditIcon="Ir a detalle"
        canDelete={false}
      />
    </Grid>
  );
};

export default ClientesCorporativosFiltersMotivos;
